import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Basic info", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "Packages", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "Billing info", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_agreement_basic_info_form = _resolveComponent("agreement-basic-info-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_form_field_packages = _resolveComponent("form-field-packages")!
  const _component_agreement_form_field_billing_template_id = _resolveComponent("agreement-form-field-billing-template-id")!
  const _component_agreement_billing_info_form = _resolveComponent("agreement-billing-info-form")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_form, {
      greedy: "",
      class: "q-gutter-md",
      onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "q-pa-lg q-mb-lg" }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_agreement_basic_info_form, {
              modelValue: _ctx.agreementPayloadModel,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agreementPayloadModel) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card, { class: "q-pa-lg q-mb-lg" }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_form_field_packages, {
              "hide-inactives": "",
              modelValue: _ctx.agreementPayloadModel.packages,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agreementPayloadModel.packages) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card, { class: "q-pa-lg q-mb-lg" }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_agreement_form_field_billing_template_id, {
              modelValue: _ctx.agreementPayloadModel.billingTemplateId,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agreementPayloadModel.billingTemplateId) = $event)),
                _ctx.onBillingTemplateChange
              ],
              organizationId: _ctx.organizationId
            }, null, 8, ["modelValue", "organizationId", "onUpdate:modelValue"]),
            (_ctx.agreementPayloadModel.billingTemplateId !== '')
              ? (_openBlock(), _createBlock(_component_agreement_billing_info_form, {
                  key: 0,
                  modelValue: _ctx.billingInfoModel,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.billingInfoModel) = $event)),
                  organizationId: _ctx.organizationId
                }, null, 8, ["modelValue", "organizationId"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_q_btn, {
          color: "primary",
          label: "Save changes",
          type: "submit",
          disable: _ctx.sending,
          "no-caps": "",
          unelevated: ""
        }, null, 8, ["disable"]),
        _createVNode(_component_q_btn, {
          to: { name: _ctx.AgreementsRouteNames.LIST, query: { page: _ctx.route.query.page } },
          label: "Back",
          color: "primary",
          outline: "",
          "no-caps": ""
        }, null, 8, ["to"])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}